import React from 'react';
import { connect } from 'react-redux';
import { Tooltip } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import { useState } from 'react';

const styles = (theme) => ({
    processTitle: {
        fontSize: " 14px",
        marginTop: "5px",
        fontWeight: "bold"
    }
});

const SaveVideoSettingsTooltip = ({
    children,
    savingInProgress,
}) => {
    return (
        <Tooltip
            title={savingInProgress ? null : 'Save Video'}
            arrow
            placement='bottom'
        >
            {children}
        </Tooltip>
    )
}

const mapStateToProps = (state) => {
    const { savingInProgress } = state.create.videoSavingState;
    return { savingInProgress }
}

const mapDispatchToProps = (dispatch) => {
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());
    return { showCriticalOperationProgressWarning }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SaveVideoSettingsTooltip, styles));